import { RadioCardGroup as BaseRadioCardGroup } from '@pulse-web-ui/radio-card-group';
import { styled } from '@pulse-web-ui/theme';

export const RadioCardGroup = styled(BaseRadioCardGroup)<{
  $direction?: string;
  $marginBottom?: number;
}>`
  flex-direction: ${({ $direction }) => $direction || 'row'};
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 0}px;
`;
